var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"scroll","padding-bottom":"8px","display":"grid","grid-auto-flow":"column","grid-gap":"8px","grid-auto-columns":"max-content"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }